import IMask from 'imask'
import DateMask from '../../components/date_mask'

const DATE_FIELDS = ['report-model-start-date', 'report-model-end-date']

class ReportModelForm {
  constructor() {
    this.regimeSelect = document.querySelector('[data-js="report-model-regime"]')
    this.selectAll = document.getElementById('select_all_entities')
    this.checkboxes = Array.from(document.querySelectorAll('.entity-checkbox'))
    this.periodicity = document.getElementById('report_model_periodicity')
    this.subtotals = document.getElementById('report_model_subtotals')

    this.applyMasks()
    this.bindRegimeChange()
    this.bindSubtotals()

    if (!this.selectAll) return

    this.bindEvents()
    this.syncSelectAll()
  }

  applyMasks() {
    if (this.isAccrual()) {
      this.applyMonthMasks()
    } else {
      new DateMask(DATE_FIELDS).execute()
    }
  }

  applyMonthMasks() {
    DATE_FIELDS.forEach((field) => {
      const input = document.querySelector(`[data-js="${field}"]`)
      if (!input) return

      const mask = IMask(input, { mask: '00/0000' })

      input.addEventListener('focus', () => mask.updateOptions({ lazy: false }))
      input.addEventListener('blur', () => {
        if (!mask.masked.isComplete) mask.value = ''
        mask.updateOptions({ lazy: true })
      })

      window.$(input).on('changeDate', () => mask.updateValue())
    })
  }

  isAccrual() {
    return this.regimeSelect && this.regimeSelect.value === 'accrual'
  }

  bindRegimeChange() {
    if (!this.regimeSelect) return

    this.regimeSelect.addEventListener('change', () => this.onRegimeChange())
  }

  onRegimeChange() {
    DATE_FIELDS.forEach((field) => {
      const input = document.querySelector(`[data-js="${field}"]`)
      if (input) this.reinitDatepicker(input)
    })

    this.applyMasks()
  }

  reinitDatepicker(el) {
    const isAccrual = this.isAccrual()
    const dateFormat = isAccrual ? 'mm/yyyy' : 'dd/mm/yyyy'
    const $el = window.$(el)

    el.value = '' // eslint-disable-line no-param-reassign
    $el.datepicker('destroy')

    if (isAccrual) {
      el.setAttribute('data-date-min-view-mode', 'months')
    } else {
      el.removeAttribute('data-date-min-view-mode')
    }

    el.setAttribute('data-date-format', dateFormat)

    $el.datepicker({
      format: dateFormat,
      orientation: 'bottom auto',
      todayHighlight: true,
      autoclose: true,
      minViewMode: isAccrual ? 'months' : 0,
    })
  }

  bindSubtotals() {
    if (!this.periodicity || !this.subtotals) return

    this.subtotalRules = JSON.parse(this.subtotals.dataset.rules || '{}')
    this.subtotalCheckboxes = Array.from(this.subtotals.querySelectorAll('.subtotal-checkbox'))

    this.periodicity.addEventListener('change', () => this.syncSubtotals())
  }

  syncSubtotals() {
    const allowed = this.subtotalRules[this.periodicity.value] || []

    this.subtotalCheckboxes.forEach((checkbox) => {
      const el = checkbox

      el.disabled = !allowed.includes(el.value)

      if (el.disabled) el.checked = false
    })
  }

  bindEvents() {
    this.selectAll.addEventListener('change', () => this.toggleAllEntities())

    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => this.syncSelectAll())
    })
  }

  toggleAllEntities() {
    this.checkboxes.forEach((checkbox) => {
      const el = checkbox

      el.checked = this.selectAll.checked
    })
  }

  syncSelectAll() {
    this.selectAll.checked = this.checkboxes.every((checkbox) => checkbox.checked)
  }
}

export default ReportModelForm
